/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Application_TitleInputs */

const en_application_title = /** @type {(inputs: Application_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application`)
};

const de_application_title = /** @type {(inputs: Application_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbung`)
};

/**
* | output |
* | --- |
* | "Application" |
*
* @param {Application_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const application_title = /** @type {((inputs?: Application_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Application_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_application_title(inputs)
	return en_application_title(inputs)
});